import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function Cart() {
  const { cart, removeFromCart, updateQuantity } = useCart();

  const itemCount = cart.reduce((sum, item) => sum + item.qty, 0);
  const total = cart.reduce((sum, item) => sum + Number(item.price) * item.qty, 0);

  if (cart.length === 0) {
    return (
      <div className="cr">
        <h2 className="cr-title">Your cart</h2>
        <div className="shop-empty">
          <h3>Your cart is empty</h3>
          <p>Browse our products and add something you like.</p>
          <Link to="/products" className="ui-btn ui-btn--primary">
            Browse products
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cr">
      <div className="cr-head">
        <h2 className="cr-title">Your cart</h2>
        <span className="cr-count">
          {itemCount} {itemCount === 1 ? "item" : "items"}
        </span>
      </div>

      <div className="cr-layout">
        <ul className="cr-list">
          {cart.map((item) => {
            const unit = Number(item.price);
            const detailPath = `/product/${item.id}`;

            return (
              <li key={item.id} className="cr-row">
                <Link to={detailPath} className="cr-img-link" aria-label={`View ${item.name}`}>
                  {item.image_url ? (
                    <img className="cr-img" src={item.image_url} alt="" />
                  ) : (
                    <span className="cr-img cr-img--empty" aria-hidden="true">
                      {item.name?.charAt(0)}
                    </span>
                  )}
                </Link>

                <div className="cr-info">
                  <Link to={detailPath} className="cr-name">
                    {item.name}
                  </Link>
                  <span className="cr-unit">£{unit.toFixed(2)} each</span>

                  <div className="cr-controls">
                    <div className="cr-qty" role="group" aria-label={`Quantity of ${item.name}`}>
                      <button
                        type="button"
                        aria-label={`Decrease quantity of ${item.name}`}
                        onClick={() => updateQuantity(item.id, -1)}
                      >
                        −
                      </button>
                      <span className="cr-qty-value" aria-live="polite">{item.qty}</span>
                      <button
                        type="button"
                        aria-label={`Increase quantity of ${item.name}`}
                        onClick={() => updateQuantity(item.id, 1)}
                      >
                        +
                      </button>
                    </div>

                    <button
                      type="button"
                      className="cr-remove"
                      aria-label={`Remove ${item.name} from your cart`}
                      onClick={() => removeFromCart(item.id)}
                    >
                      Remove
                    </button>
                  </div>
                </div>

                <div className="cr-line">£{(unit * item.qty).toFixed(2)}</div>
              </li>
            );
          })}
        </ul>

        {/* ORDER SUMMARY */}
        <aside className="cr-summary" aria-label="Order summary">
          <h3>Order summary</h3>

          <div className="cr-summary-row">
            <span>Items ({itemCount})</span>
            <span>£{total.toFixed(2)}</span>
          </div>

          <div className="cr-summary-row cr-summary-total">
            <span>Total</span>
            <span>£{total.toFixed(2)}</span>
          </div>

          <p className="cr-summary-note">Delivery is calculated at checkout.</p>

          <Link to="/checkout" className="ui-btn ui-btn--primary ui-btn--block">
            Proceed to checkout
          </Link>
          <Link to="/products" className="ui-btn ui-btn--ghost ui-btn--block">
            Continue shopping
          </Link>
        </aside>
      </div>
    </div>
  );
}